import { UuiExpansionPanel, UuiExpansionPanelBody, UuiExpansionPanelHeader } from "@aonunited/react";
import React from "react";
var AonPannel = function (props) {
    return (React.createElement(UuiExpansionPanel, { expanded: props.expanded !== undefined ? props.expanded : true, variant: "light", panelId: "panel1" },
        React.createElement(UuiExpansionPanelHeader, { header: props.headerTitle, description: props.HeaderDesc, direction: "row" }),
        React.createElement(UuiExpansionPanelBody, null, props.Body ? props.Body : null)));
};
export default AonPannel;
